// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"SimpleTextSettingsList_contentComponent__2SPEG","tableContainer":"SimpleTextSettingsList_tableContainer__3wcOz","root":"SimpleTextSettingsList_root__p-38b"};